import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { CardContent, CardContentProps, Typography } from '@mui/material';

import { Offering } from '@arrived/models';

import { getAssetTypeFormattedMessage } from '../../../PropertyTag';

export interface PropertyGridCardContentProps extends CardContentProps {
  offering: Offering;
}

export const PropertyGridCardContent = ({ offering, sx, ...rest }: PropertyGridCardContentProps) => {
  const { assetType, market } = offering;

  const assetTypeFormattedMessage = useMemo(() => getAssetTypeFormattedMessage(assetType), [assetType]);

  return (
    <CardContent
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
        width: '100%',
        ...sx,
      }}
      {...rest}
    >
      <Typography variant="h6.medium" mb={0.5}>
        {offering.name}
      </Typography>
      {market == null ? null : <Typography color="darkened.steel">{market.title}</Typography>}
      <Typography color="darkened.steel">
        <FormattedMessage {...assetTypeFormattedMessage} />
      </Typography>
    </CardContent>
  );
};
